import { Autocomplete as MaterialAutocomplete } from "@material-ui/lab";
import TextField from "../textField";
import React, { MutableRefObject } from "react";
import { makeStyles } from "@material-ui/core";

interface AutocompleteProps {
  alwaysPresentOptions?: string[];
  defaultValue?: string;
  label: string;
  onFocus?: () => void;
  onOptionSelected?: (event: React.ChangeEvent<HTMLDataListElement>) => void;
  options: string[];
  reference?: MutableRefObject<HTMLElement>;
}

const Autocomplete: React.FunctionComponent<AutocompleteProps> = ({
  options,
  alwaysPresentOptions = [],
  label,
  onOptionSelected,
  onFocus,
  reference,
  defaultValue,
}) => {
  const classes = useStyle();
  return (
    <MaterialAutocomplete
      className={classes.noMarginOnFieldEnd}
      disablePortal={true}
      options={options}
      renderInput={(params) => <TextField {...params} label={label} />}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) => alwaysPresentOptions.includes(option) || option.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      onChange={onOptionSelected}
      defaultValue={defaultValue}
      onFocus={onFocus}
      ref={reference}
    />
  );
};

const useStyle = makeStyles(() => ({
  noMarginOnFieldEnd: {
    "& div.MuiAutocomplete-endAdornment": {
      marginTop: 0,
    },
  },
}));

export default Autocomplete;
